<script setup lang="ts">
import TopHeader from "@/components/TopHeader.vue";
import {useScroll} from "@vueuse/core";

const el = ref<HTMLElement | null>(null)
const {y} = useScroll(el,)
const router = useRouter()
const route = useRoute()
const baseUrl = 'https://mody.at'

watch(router.currentRoute,()=>{
  console.log(router.currentRoute.value.fullPath)
  if(!router.currentRoute.value.fullPath.includes("/shop/category")){
    setTimeout(()=>{
      y.value = 0;
    },100)
  }
})
useHead({
  htmlAttrs: {
    lang: 'de',
  },
  link: [
  {
    rel: 'canonical',
    href: baseUrl + route.fullPath.split('?')[0], // Querystrings entfernen
  }
  ]
})

const hideMenu = computed(() => {
  return router.currentRoute.value.fullPath.includes("/landingpages")
})

const hideWhatsApp = computed(() => {
  const path = router.currentRoute.value.fullPath
  return path.includes("/admin") || path.includes("/landingpages") || path === "/shop/request"
})

const isAdmin = computed(() => router.currentRoute.value.fullPath.includes('/admin'))

</script>

<template>
  <CookieControl locale="de" />
  <TopHeader v-if="!hideMenu"/>
  <div :class="{ 'public-shell': !isAdmin }">
    <NuxtPage />
    <Footer/>
  </div>
  <a
    v-if="!hideWhatsApp"
    href="https://wa.me/436642247433?text=Hallo%2C%20ich%20interessiere%20mich%20f%C3%BCr%20euer%20Equipment%20f%C3%BCr%20mein%20Event."
    target="_blank"
    rel="noopener noreferrer"
    class="whatsapp-fab"
    aria-label="WhatsApp Kontakt"
  >
    <i class="pi pi-whatsapp"></i>
  </a>

</template>

<style lang="scss">
@import url("bootstrap/dist/css/bootstrap-grid.css");
@import url("bootstrap/dist/css/bootstrap-utilities.css");
/*.p-scrollpanel{
  height: calc(100% - 76px);
  .p-scrollpanel-content{
    scroll-snap-type: y proximity;
    padding:0;
    width: unset;*/
    
    .slot {
      min-height: 100vh;
      position: relative;
      scroll-snap-align: start;
      overflow:hidden;
    }
    /*  }*/
    .p-scrollpanel-bar{
      display:none;
    }
    /*}*/
    a{
      color:unset;
    }

  .whatsapp-fab {
    position: fixed;
    bottom: 24px;
    left: 24px;
    z-index: 1000;
    border: 1px solid rgba(37, 211, 102, 0.34);
    background-color: #17221b;
    color: #45d879;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.24);
    transition: border-color 180ms $public-ease, background-color 180ms $public-ease;
    text-decoration: none;

    .pi-whatsapp {
      font-size: 1.45rem;
    }

    &:hover {
      border-color: rgba(37, 211, 102, 0.62);
      background-color: #1a2b20;
    }
  }

  .cookieControl__ControlButton {
    width: 44px !important;
    min-width: 44px !important;
    height: 44px !important;
    min-height: 44px !important;
  }

  @media (max-width: 639px) {
    .whatsapp-fab {
      display: none;
    }
  }
    html,body, #__nuxt, #__layout{
      width:100vw;
      overflow-x: hidden;
      margin:0;
    }
  </style>
